<form [ngClass]="{'needs-validation': !frmM.submitted, 'was-validated': frmM.submitted}"
      novalidate #frmM="ngForm" (ngSubmit)="onSalvarMovimentacao()"  >

  <section class="etapa-movimentacao mt-3">
    <h5 class="etapa-titulo">
      <span class="etapa-numero">1</span>
      Tipo da movimentação
    </h5>
    <div class="opcoes-movimentacao">
      <label class="opcao-movimentacao" [class.selecionada]="tipoSelecionado === 'entrada'">
        <span class="opcao-icone entrada"><i class="fas fa-arrow-down"></i></span>
        <span class="opcao-texto">
          <b>Entrada</b>
          <small>Adiciona quantidade ao estoque</small>
        </span>
        <input type="radio" name="tipoMovimentacao" value="entrada" kendoRadioButton required
               [(ngModel)]="tipoSelecionado" (change)="alterouTipo('entrada')">
      </label>

      <label class="opcao-movimentacao" [class.selecionada]="tipoSelecionado === 'saida'">
        <span class="opcao-icone saida"><i class="fas fa-arrow-up"></i></span>
        <span class="opcao-texto">
          <b>Saída</b>
          <small>Retira quantidade do estoque</small>
        </span>
        <input type="radio" name="tipoMovimentacao" value="saida" kendoRadioButton required
               [(ngModel)]="tipoSelecionado" (change)="alterouTipo('saida')">
      </label>
    </div>
  </section>

  <section class="etapa-movimentacao" *ngIf="tipoSelecionado">
    <h5 class="etapa-titulo">
      <span class="etapa-numero">2</span>
      Motivo
    </h5>
    <div class="opcoes-movimentacao">
      <label class="opcao-movimentacao opcao-motivo"
             *ngFor="let motivo of motivosDoTipo()"
             [class.selecionada]="movimentacao.motivoDaMovimentacao?.id === motivo.id">
        <span class="opcao-icone motivo"><i [ngClass]="iconeDoMotivo(motivo)"></i></span>
        <span class="opcao-texto"><b>{{motivo.descricao}}</b></span>
        <input type="radio" name="motivoMovimentacao" kendoRadioButton required
               [value]="motivo" [(ngModel)]="movimentacao.motivoDaMovimentacao"
               (change)="alterouMotivo(motivo)">
      </label>
    </div>
  </section>

  <ng-container *ngIf="movimentacao.motivoDaMovimentacao">
    <div class="orientacao-movimentacao" *ngIf="entradaPorBenefiamento()">
      <i class="fas fa-info-circle"></i>
      <div>
        <b>Como informar a produção</b>
        <p class="mb-0 mt-1">
          Informe em <b>Quantidade</b> o total que foi produzido, e não o número de vezes que a receita foi preparada.
          O sistema aplicará a receita proporcionalmente, baixará o consumo de cada ingrediente e adicionará a quantidade
          informada ao estoque do item beneficiado.
        </p>
      </div>
    </div>

    <section class="etapa-movimentacao">
      <h5 class="etapa-titulo">
        <span class="etapa-numero">3</span>
        Dados da movimentação
      </h5>
      <div class="row mb-2">
        <div class="form-group col-12 col-sm-6" *ngIf="movimentacao.insumo">
          <label>Quantidade</label>
          <kendo-numerictextbox id="quantidade" [min]="0.1" [format]="obtenhaFormato()"
                                class="form-control" name="quantidade" #quantidade=ngModel
                                (valueChange)="alterouQuantidade(movimentacao, $event)"
                                [(ngModel)]="movimentacao.quantidade" required
                                placeholder="quantidade em {{obtenhaDescricaoUnidade(movimentacao.insumo)}}">
          </kendo-numerictextbox>

          <div class="invalid-feedback">
            <p *ngIf="quantidade.errors?.required">Quantidade é obrigatória</p>
            <p *ngIf="quantidade.errors?.minError">Quantidade deve ser maior que 0</p>
          </div>
        </div>

        <div class="form-group col-12" [class.col-sm-6]="!!movimentacao.insumo">
          <label for="horario">Data de movimentação</label>
          <div class="input-group">
            <kendo-datepicker [(ngModel)]="movimentacao.horario" id="horario"
                              name="horario" #horario=ngModel [format]="'dd/MM/yyyy HH:mm'"
                              class="form-control k-display-inline-block" required>
              <kendo-datepicker-messages today="Hoje" toggle="Alterar data"></kendo-datepicker-messages>
            </kendo-datepicker>

            <div class="invalid-feedback">
              <p *ngIf="horario.errors?.required">Data é obrigatória</p>
            </div>
          </div>
        </div>
      </div>

  <div class="row mb-2" *ngIf="controleCustoEstoqueAtivo && !varios && entradaComCustoInformado()">
    <div class="form-group col-6">
      <label>Custo unitário</label>
      <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                            class="form-control" name="custoUnitario"
                            [(ngModel)]="movimentacao.custoUnitario"
                            (valueChange)="alterouCustoUnitario(movimentacao, $event)" required>
      </kendo-numerictextbox>
    </div>
    <div class="form-group col-6">
      <label>Custo total</label>
      <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                            class="form-control" name="custoTotal"
                            [(ngModel)]="movimentacao.custoTotal"
                            (valueChange)="alterouCustoTotal(movimentacao, $event)" required>
      </kendo-numerictextbox>
    </div>
  </div>

  <div class="row mb-2" *ngIf="controleCustoEstoqueAtivo && !varios && saidaComCustoCalculado()">
    <div class="form-group col-6">
      <label>Custo médio vigente</label>
      <div class="form-control bg-light">
        {{custoMedioAtual(movimentacao) == null ? 'Desconhecido' : (custoMedioAtual(movimentacao) | currency:'BRL')}}
      </div>
    </div>
    <div class="form-group col-6">
      <label>Custo total previsto</label>
      <div class="form-control bg-light">
        {{custoTotalPrevisto(movimentacao) == null ? '—' : (custoTotalPrevisto(movimentacao) | currency:'BRL')}}
      </div>
    </div>
    <div class="col-12 text-danger" *ngIf="custoDesconhecido(movimentacao)">
      O estoque está sem custo conhecido; a saída será bloqueada até que o custo seja informado.
    </div>
  </div>

  <div class="row mb-2 campo-observacao">
    <div class="form-group  col-12">
      <label>Observação <span class="text-muted">(opcional)</span></label>

      <textarea type="text" class="form-control" autocomplete="off" maxlength="255"
                id="observacao" name="observacao" [(ngModel)]="movimentacao.observacao" #observacao="ngModel"
                placeholder="Inclua uma observação se desejar" value=""  >
                 </textarea>
      <small class="contador-caracteres">{{(movimentacao.observacao || '').length}}/255</small>
    </div>
  </div>

  <div class="row mb-2" *ngIf="exigeJustificativa()">
    <div class="form-group col-12">
      <label>Justificativa</label>
      <textarea class="form-control" maxlength="500" name="justificativa"
                [(ngModel)]="movimentacao.justificativa" required
                placeholder="Explique a perda ou o ajuste realizado"></textarea>
    </div>
  </div>

  <div *ngIf="varios">
    <kendo-grid    [data]="movimentacoes"  >
      <kendo-grid-messages
        pagerPage="Página"
        pagerOf="de"
        pagerItems="itens"
        noRecords="Nenhum grupo cadastrado"
        loading="Carregando"
        pagerItemsPerPage="ítems por página"
      >
      </kendo-grid-messages>

      <kendo-grid-column    [width]="30">
        <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
          <span [class.removido]="dataItem.removido">         {{rowIndex + 1}}</span>

        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column   title="Insumo" [width]="300">
        <ng-template kendoGridGroupHeaderTemplate let-value="value">
            {{entradaPorBenefiamento() ? 'Receita' : 'Insumo'}}
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <app-selecionar-insumo [exbirLabel]="false" [selectedItem]="dataItem" [indice]="rowIndex" [formClass]="''"
                                 (onAlterou)="alterouInsumoDaMovimentacao()">

          </app-selecionar-insumo>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Qtde"  [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div class="form-group mb-0">
            <kendo-numerictextbox   [min]="0.1"   [format]="obtenhaFormatoDoInsumo(dataItem.insumo)"
                                  class="form-control" name="quantidade{{rowIndex}}" #quantidade=ngModel
                                  (valueChange)="alterouQuantidade(dataItem, $event)"
                                  [(ngModel)]="dataItem.quantidade" required
                                  placeholder="quantidade em {{obtenhaDescricaoUnidade(dataItem.insumo)}}">
            </kendo-numerictextbox>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Custo unit." [width]="170" *ngIf="entradaComCustoInformado()">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                                class="form-control" name="custoUnitario{{rowIndex}}"
                                [(ngModel)]="dataItem.custoUnitario"
                                (valueChange)="alterouCustoUnitario(dataItem, $event)" required>
          </kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Custo total" [width]="170" *ngIf="entradaComCustoInformado()">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                                class="form-control" name="custoTotal{{rowIndex}}"
                                [(ngModel)]="dataItem.custoTotal"
                                (valueChange)="alterouCustoTotal(dataItem, $event)" required>
          </kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Custo calculado" [width]="190" *ngIf="saidaComCustoCalculado()">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="!custoDesconhecido(dataItem)">
            {{custoMedioAtual(dataItem) | currency:'BRL'}} / {{custoTotalPrevisto(dataItem) | currency:'BRL'}}
          </span>
          <span class="text-danger" *ngIf="custoDesconhecido(dataItem)">Custo desconhecido</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title=""  [class]="{'comandos': true}" [width]="100">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-item let-rowIndex="rowIndex">
          <button kendoGridRemoveCommand kendoTooltip title="remover" (click)="removaMovimentacao(rowIndex)"   >
            <i class="fa fa-trash text-danger"></i>
          </button>
        </ng-template>

      </kendo-grid-command-column>

    </kendo-grid>

    <button class="btn btn-outline-blue btn-xs mb-3 mt-2" type="button" (click)="novaMovimentacao()">
      <b> <i class="fe-plus"></i> Adicionar</b> </button>

  </div>

    </section>
  </ng-container>

  <div class="alert alert-info" *ngIf="carregandoPreviaBeneficiamento">
    <i class="k-icon k-i-loading mr-1"></i> Calculando o resultado do beneficiamento...
  </div>

  <div class="alert alert-danger" *ngIf="erroPreviaBeneficiamento">
    {{erroPreviaBeneficiamento}}
  </div>

  <section class="resultado-previa" *ngIf="previaBeneficiamento">
    <header class="resultado-previa-cabecalho">
      <span class="resultado-previa-icone"><i class="fas fa-calculator"></i></span>
      <div>
        <h5>Resultado depois de salvar</h5>
        <small>Confira como ficarão o estoque e o custo desta produção.</small>
      </div>
    </header>

    <div class="resultado-previa-item"
         *ngFor="let item of previaBeneficiamento.itens; let ultimo = last"
         [class.ultimo]="ultimo">
      <div class="resultado-previa-nome" *ngIf="varios">
        <i class="fas fa-box mr-1"></i> {{item.insumo?.nome}}
      </div>

      <div class="fluxo-estoque">
        <div class="fluxo-estoque-valor">
          <span>Estoque atual</span>
          <b>{{item.quantidadeEstoqueAtual | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</b>
        </div>
        <i class="fas fa-arrow-right fluxo-estoque-seta"></i>
        <div class="fluxo-estoque-valor entrada">
          <span>Entrada produzida</span>
          <b>+ {{item.quantidadeProduzida | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</b>
        </div>
        <i class="fas fa-arrow-right fluxo-estoque-seta"></i>
        <div class="fluxo-estoque-valor resultado">
          <span>Estoque depois de salvar</span>
          <b>{{item.quantidadeEstoqueResultante | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</b>
        </div>
      </div>

      <div class="resultado-custos" *ngIf="item.custoMedioResultante != null">
        <div>
          <span>Custo médio atual</span>
          <b>{{item.custoMedioAtual == null ? 'Desconhecido' : (item.custoMedioAtual | currency:'BRL':'symbol':'1.2-6')}}</b>
        </div>
        <div class="resultado-custo-final">
          <span>Custo médio depois de salvar</span>
          <b>{{item.custoMedioResultante | currency:'BRL':'symbol':'1.2-6'}}</b>
        </div>
      </div>

      <div class="resultado-receita">
        <div class="resultado-receita-titulo">
          <span class="resultado-receita-icone"><i class="fas fa-utensils"></i></span>
          <div>
            <b>Receita aplicada para produzir {{item.quantidadeProduzida | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</b>
            <small>Rendimento cadastrado: {{item.rendimentoReceita | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</small>
          </div>
        </div>
        <p>Consumo previsto dos ingredientes</p>
        <div class="resultado-ingredientes">
          <div *ngFor="let ingrediente of item.ingredientes">
            <span>{{ingrediente.nome}}</span>
            <b>{{ingrediente.quantidadeConsumida | number:'1.0-3'}}<ng-container *ngIf="ingrediente.unidade"> {{ingrediente.unidade}}</ng-container></b>
          </div>
        </div>
      </div>
    </div>

    <footer class="resultado-previa-rodape">
      <i class="fas fa-info-circle mr-1"></i>
      O resultado definitivo será recalculado ao salvar.
    </footer>
  </section>

  <div class="alert alert-info" *ngIf="resultadoBeneficiamento">
    Beneficiamento processado pelo custo calculado no servidor:
    <b>{{resultadoBeneficiamento.custoTotal | currency:'BRL'}}</b> total,
    média resultante <b>{{resultadoBeneficiamento.custoMedioResultante | currency:'BRL'}}</b>.
  </div>


  <div class="modal-footer">

    <p  *ngIf="mensagemErro" class="text-danger ">
      <i class="mdi mdi-check-all mr-1"></i> {{mensagemErro}}
    </p>

    <button type="button" class="btn btn-light waves-effect" data-dismiss="modal"
            (click)="canceleMovimentacao()">Cancelar</button>

    <button type="submit" class="btn btn-success waves-effect waves-light"
            [disabled]="salvando || carregandoStatusControleCusto || !!erroPreviaBeneficiamento || !tipoSelecionado || !movimentacao.motivoDaMovimentacao">
      <i *ngIf="salvando" class="k-icon k-i-loading"></i>
      <i *ngIf="!salvando" class="fas fa-check mr-1"></i>Salvar movimentação</button>
  </div>

</form>
